var BaseView = require('./base');

module.exports = BaseView.extend({
  uploadConfig: {
    validation: {
      acceptFiles: '.pdf, .psd,  .ppt, .pptx',
      allowedExtensions: ['pdf', 'psd', 'ppt', 'pptx']
    },
    uploadSuccess: {params: {loadType: 120}}
  },

  appendThumbnails: function (data) {
    var $content = this.$el.find('.thumbnail-wrapper');

    var results = _.each(this.extractTextData(data), function (textThumb) {
      this.$el.find('#' + textThumb.uuid).length || textThumb.appendTo($content);
      this.addDeleteOverlay(this.$el.find('#' + textThumb.uuid));
    }, this);

    if (results.length) {
      var $innerTabs = this.$el.parents('.inner-tabs');
      var $activeTab = $innerTabs.find('.header-links').find('.active');

      if ($activeTab.data('key') === 'add') {
        this.$el.siblings('.section-title').css('visibility', '');
      }
    }

    this.masonryReload();
  },

  extractTextData: function (data) {
    return _.compact(_.map(data, function (item) {
      if (item.type === 'text') {
        return new INKIVE.ThumbText($.extend(item, {tooltip: data.text}));
      }
    }, this));
  },

  getScrollHeight: function ($target) {
    var $tabContent = $target.closest('.tab-content');
    var containerHeight = $tabContent.height();

    containerHeight -= $tabContent.find('.header-links').height();
    containerHeight -= parseInt($tabContent.find('.search-container').css('height'));

    $target.siblings().add($target.parent().siblings()).each(function () {
      containerHeight -= $(this).height();
    });

    return containerHeight;
  },

  getScrollWidth: function ($target) {
    return $target.width();
  }
});
